import { render } from "./StatusDot.vue?vue&type=template&id=f2cde178&scoped=true"
import script from "./StatusDot.vue?vue&type=script&lang=js"
export * from "./StatusDot.vue?vue&type=script&lang=js"

import "./StatusDot.vue?vue&type=style&index=0&id=f2cde178&scoped=true&lang=css"

import exportComponent from "../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2cde178"]])

export default __exports__